import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams, useLocation } from "react-router-dom";

import { changeLanguage } from "../../components/I18N/TranslateHelpers";
import SearchResultsContainer from "./SearchResultsContainer";
import SearchResultsTitle from "./SearchResultsTitle";
import { getSearchResults } from "./searchResultsSlice";

interface ComponentProps {
    keywords?: string | null;
}

export interface SearchModeProp {
    locale: string;
    keywords?: string | null;
}

const SearchResultsPage: React.FC<ComponentProps> = () => {
    const dispatch = useDispatch();
    const { locale = "fr" } = useParams<{ locale: string }>(); // ← remplace match.params.locale
    const location = useLocation();                            // ← remplace location.search

    changeLanguage(locale);

    const [keywordsFilters, setKeywordsFilters] = useState<string | null>(null);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const keywords = searchParams.get("keys");

        setKeywordsFilters(keywords);
        dispatch(getSearchResults(keywords));
    }, [dispatch, location.search]);

    return (
        <div className="bg-light-gray">
            <SearchResultsTitle locale={locale} keywords={keywordsFilters} />
            <SearchResultsContainer locale={locale} keywords={keywordsFilters} />
        </div>
    );
};

export default SearchResultsPage;
